<template>
  <div>
    <div v-if="displayGraphBlock" class="block">

      <div v-if="btnTimeLineSelected" class="col-xs-12 col-sm-6 col-md-3">
        <p><button @click="flagDisplayChannelJournal=false" type="button " class="btn btn-block btn-sm disabled" name="button"><i class="fa fa-area-chart fa-1x"></i> {{ buttonLabelTimeSeries[actualLanguage] }}</button></p>
      </div>
      <div v-else class="col-xs-12 col-sm-6 col-md-3">
        <p><button @click="selectTimeLine()" type="button " class="btn btn-block btn-sm" name="button"><i class="fa fa-area-chart fa-1x"></i> {{ buttonLabelTimeSeries[actualLanguage] }}</button></p>
      </div>


      <div v-if="btnHistogramSelected" class="col-xs-12 col-sm-6 col-md-3">
        <p><button @click="flagDisplayChannelJournal=false" type="button " class="btn btn-block btn-sm disabled" name="button"><i class="fa fa-bar-chart fa-1x"></i> {{buttonLabelHistogram[actualLanguage] }}</button></p>
      </div>
      <div v-else class="col-xs-12 col-sm-6 col-md-3">
        <p><button @click="selectHistogram()" type="button " class="btn btn-block btn-sm" name="button"><i class="fa fa-bar-chart fa-1x"></i> {{buttonLabelHistogram[actualLanguage] }}</button></p>
      </div>

      
      <div v-if="btnMovingAverageSelected" class="col-xs-12 col-sm-6 col-md-3">
        <p><button @click="btnMovingAverageSelected=false" type="button " class="btn btn-block btn-sm disabled" name="button"><i class="fa fa-line-chart fa-1x"></i> {{ buttonLabelMovingAverage[actualLanguage] }}</button></p>
      </div>
      <div v-else class="col-xs-12 col-sm-6 col-md-3">
        <p><button @click="selectMovingAverage()" type="button " class="btn btn-block btn-sm" name="button"><i class="fa fa-line-chart fa-1x"></i> {{ buttonLabelMovingAverage[actualLanguage] }}</button></p>
      </div>




      <div v-if="btnSessionsSelected" class="col-xs-12 col-sm-6 col-md-3">
        <p><button @click="flagDisplayChannelJournal=false" type="button " class="btn btn-block btn-sm disabled" name="button"><i class="fa fa-bar-chart fa-1x"></i> Sessions</button></p>
      </div>
      <div v-else class="col-xs-12 col-sm-6 col-md-3">
        <p><button @click="selectSession()" type="button " class="btn btn-block btn-sm" name="button"><i class="fa fa-bar-chart fa-1x"></i> Sessions</button></p>
      </div>





      <div class="block-content text-right" >
        
        <div v-if="btnTimeLineSelected" class="col-sm-12">
          <port-graph :channelIndex="channelIndex"></port-graph>
        </div>

        <div v-if="btnMovingAverageSelected" class="col-sm-12">
          <moving-average-graph :channel_id="actualBundle.channels[channelIndex].ChannelData.channelId"></moving-average-graph>
        </div>


        <div v-if="btnHistogramSelected" class="col-sm-12">
          <histogram-graph :channelIndex="channelIndex"></histogram-graph>
        </div>

        <div v-if="btnSessionsSelected" class="col-sm-12">
          <sessions-graph :channel_id="actualBundle.channels[channelIndex].ChannelData.channelId"></sessions-graph>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'
import PortGraph from './PortGraph.vue'
import HistogramGraph from './HistogramGraph'
import DataTable from './DataTable'
import MovingAverageGraph from './MovingAverageGraph'
import SessionsGraph from './SessionsGraph'

export default {
  props: ['channelIndex'],
  components: {
    PortGraph,
    DataTable,
    MovingAverageGraph,
    HistogramGraph,
    SessionsGraph,
  },
  data() {
    return {
      timeRange : 0,
      actualLanguage : "FR",
      channelReadings : [],
      btnTimeLineSelected : true,
      displayGraphBlock : true,
      btnHistogramSelected : false,
      btnSessionsSelected : false,
      btnMovingAverageSelected : false,

      buttonLabelTimeSeries:{FR: "Mesures temporelles", EN: 'Time series'},
      buttonLabelMovingAverage:{FR: "Moyennes mobiles", EN: 'Moving average'},
      buttonLabelHistogram:{FR: "Histogramme", EN: 'Histogram'},
      textSectionTableau:{FR: "Tableau des mesures", EN: 'Measurement table'},

    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('chargesStore',['startDate', 'endDate']),
  },
/*
  watch: {
    actualBundle(){

        //console.log('---MultipleGraph:Watcher launch-----')
        //console.log(this.actualBundle.channels[this.channelIndex].ChannelData.Readings.length)
        
        //this.displayGraphBlock = false
        //this.timeFunction()
        //this.channelReadings = this.actualBundle.channels[this.channelIndex].ChannelData.Readings
        //this.channelReadings = JSON.parse(JSON.stringify(this.actualBundle.channels[this.channelIndex].ChannelData.Readings))
        this.displayGraphBlock = true
    },
    displayAllChannelGraphFlag(){
        //console.log('---MultipleGraph:Watcher Display all channel-----')
        //console.log(this.displayAllChannelGraphFlag)
        //this.displayGraphBlock = this.displayAllChannelGraphFlag
    },
  },
  */

  methods: {
    selectTimeLine(){
        this.btnTimeLineSelected = true
        this.btnHistogramSelected = false
        this.btnSessionsSelected = false
        this.btnMovingAverageSelected = false
      },

     selectHistogram(){
        this.btnTimeLineSelected = false
        this.btnHistogramSelected = true
        this.btnSessionsSelected = false
        this.btnMovingAverageSelected = false
      },

    selectSession(){
        this.btnTimeLineSelected = false
        this.btnHistogramSelected = false
        this.btnSessionsSelected = true
        this.btnMovingAverageSelected = false
      },

    selectMovingAverage(){
        this.btnTimeLineSelected = false
        this.btnHistogramSelected = false
        this.btnSessionsSelected = false
        this.btnMovingAverageSelected = true
      },

   computeTimeRange(){
        this.timeRange = this.endDate - this.startDate
      },


    },

  mounted() {
    this.computeTimeRange()
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    
  },
  beforeMount(){
    this.channelReadings = this.actualBundle.channels[this.channelIndex].ChannelData.Readings
  },


}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// MultipleGraph.vue?441742a6